// extracted by mini-css-extract-plugin
module.exports = {"snsIconSet":"styles_snsIconSet__yJW3p","snsIcon":"styles_snsIcon__7Pish","snsImg":"styles_snsImg__r49Yp"};